





















import ConsultantItem from '../common/consultant_item.vue'
import { Component, Mixins, Inject, Provide } from 'vue-property-decorator'
import SearchCategory from '../common/search_category.vue'
import SearchLoadList from '../mixins/LoadList'
import Screen from '../common/search_screen.vue'
import { List, Toast, Sticky } from 'vant'
import { namespace } from 'vuex-class'
import { SearchRefresh } from '../searchAll/index.vue'
import { getSearchResult, RequestType } from '../../search-service'
const searchResModule = namespace('searchRes') //vuex

@Component({
  components: {
    [List.name]: List,
    [Sticky.name]: Sticky,
    ConsultantItem,
    SearchCategory,
    Screen
  }
})
export default class SearchYuer extends Mixins(SearchLoadList) {
  @searchResModule.Mutation setYuerNum!: (arg: number) => void
  @searchResModule.State location!: any
  @searchResModule.State storeList!: any
  @searchResModule.State yuerStoreSelect!: any
  @searchResModule.Mutation setYuerStoreSelect!: any

  @searchResModule.State yuerDistanceSort!: boolean
  @searchResModule.State yuerGoodCommentsSort!: boolean
  @searchResModule.Mutation setYuerDistanceSort!: (arg: any) => void //设置育儿顾问距离排序
  @searchResModule.Mutation setYuerGoodCommentsSort!: (arg: any) => void //设置育儿顾问销量排序
  @searchResModule.Mutation resetYuer!: () => void //重置筛选项

  @Inject('pageTrackParams')
  pageTrackParams!: any
  @Inject('clickid_200011')
  clickid_200011!: string

  @Provide()
  clickid_200007 = '200007'

  mounted() {
    const { searchKey = '', tabs = '' } = this.$route.query
    this.keyWord = searchKey as string
    this.tabs = tabs as string
    this.onLoad()
    setTimeout(() => {
      this.$bus.$on(SearchRefresh.RefreshConsultant, () => {
        this.refresh()
      })
    }, 1000)
  }

  //距离排序是否展示
  get locationVis() {
    return this.location && this.location.lat && this.location.lng
  }

  destroyed() {
    this.$bus.$off(SearchRefresh.RefreshConsultant)
  }

  get emptyHeight() {
    const { top, height } = (this.$refs.classify as HTMLElement).getBoundingClientRect() || {}
    return document.body.clientHeight - top - height
  }

  get classifyExposure() {
    return `${this.clickid_200011}`
  }

  changeYuerStore(value: any) {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '门店' } })
    this.setYuerStoreSelect(value)
    this.refresh()
  }

  changeYuerDistanceSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '距离' } })
    if (this.loading) return
    this.setYuerDistanceSort(!this.yuerDistanceSort)
    if (this.yuerDistanceSort) {
      this.setYuerGoodCommentsSort(false)
    }
    this.refresh()
  }

  changeYuerGoodCommentsSort() {
    this.$newClickTracker({ ...this.pageTrackParams, clickId: this.clickid_200011, positionParam: { searchtype: '好评' } })
    if (this.loading) return
    this.setYuerGoodCommentsSort(!this.yuerGoodCommentsSort)
    if (this.yuerGoodCommentsSort) {
      this.setYuerDistanceSort(false)
    }
    this.refresh()
  }

  async onLoad() {
    const { storeCode = '' } = this.yuerStoreSelect || {}
    const result = await getSearchResult({ tabs: this.tabs, keyWords: this.keyWord, type: RequestType.RequestConsultant, start: this.start, position: this.location, storeCode, storeFavPersonNumSort: this.yuerGoodCommentsSort, distanceSort: this.yuerDistanceSort })
    const { code, data, msg } = result
    if (+code === 1) {
      if (data.cmmdtyInfo) {
        const { total, list: newData = [] } = data.adviserInfo
        this.setYuerNum(total)
        if (newData.length < 10) {
          this.finished = true
        }
        this.start = this.start + newData.length
        this.list.push(...newData)
      }
    } else {
      this.errormsg = msg || '加载出错，请稍后再试'
      if (this.list.length > 0) {
        this.error = true
        Toast(this.errormsg)
      }
    }
    this.loading = false
  }

  refresh() {
    this.reset()
    this.$nextTick(() => {
      if (this.isFixed) {
        window.scrollTo(0, this.scrollTop)
      }
    })
    this.onLoad()
  }

  resetCondition() {
    this.resetYuer()
    this.refresh()
  }
}
